import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import PageLayout from '../components/templates/page-layout/page-layout'
import Button from '../components/atoms/button/button'
import { triggerPageView, triggerTag } from '../utils/taggeo'
import CrazyEgg from '../utils/CrazyEgg'
import { LOCALE } from '../constants/activity-constants'
import HomePrizes from '../components/molecules/home-prizes/home-prizes'
import './styles/index.scss'
import useMediaQuery from '../utils/useMediaQuery'

const dateActivity = () => {
  if (LOCALE === 'es-EC') return '1 de abril hasta el 30 de noviembre de 2024'
  if (LOCALE === 'es-PE') return '8 de abril hasta el 26 de noviembre de 2024'
  return '4 de marzo al 31 de agosto de 2024.'
}

CrazyEgg()
function IndexPage() {
  const isMobile = useMediaQuery()
  const handlePlay = (
    event: React.MouseEvent<HTMLElement, globalThis.MouseEvent>
  ) => {
    triggerTag('7A', { label: (event.target as HTMLElement).textContent })

    navigate('/jugar')
  }

  useEffect(() => {
    triggerPageView()
  }, [])
  return (
    <PageLayout className="background-home">
      <div className="flex full-view f-home">
        <div className="f-home_logo">
          <Button className="f-home_button-desk" onClick={handlePlay}>
            Jugar ya
          </Button>
        </div>
        <section className="f-home_description">
          <div className="f-home_description_wrapper">
            <h1>
              <span>¡Regresamos</span> con más diversión a tu colegio!
            </h1>
            <p>
              Participa en los 3 juegos que Nosotras trae para ti. Obtén vidas
              registrando la clave de tus empaques,
            </p>
            <p>
              <i>
                juega las veces que quieras y gana premios increíbles. Entre más
                participes, más posibilidades tendrás de ganar.
              </i>
            </p>
            <p className="f-home_description_text-date">
              <i>Actividad del {dateActivity()}</i>
            </p>
          </div>
          <StaticImage
            src="../assets/images/home/control.png"
            alt="control de videojuegos"
            className="f-home_description_control"
            placeholder="blurred"
            width={76}
          />
          <Button className="f-home_description_button" onClick={handlePlay}>
            Jugar ya
          </Button>
        </section>
        <section className="f-home-prize">
          <div className="f-home-prize_title">
            <h2>{textPrizes}</h2>
          </div>
          <HomePrizes isMobile={isMobile} />
        </section>
      </div>
    </PageLayout>
  )
}

export default IndexPage

const textPrizes = {
  'es-CO': '¡Gana uno de los 3 Iphones 14 que tenemos para ti!',
  'es-EC': '¡Gana uno de los 2 Iphones 14 que tenemos para ti!',
  'es-PE': '¡Gánate un Iphone 14 y muchos  premios más!',
}[LOCALE]
